import PdfLayout from '../PdfLayout';
import CustomTextWidget from './CustomTextWidget';

export const LAUSANNE_ENTERTAINMENT_TAX_PAID = 'Impôt et frais compris';
export const LAUSANNE_ENTERTAINMENT_TAX_FREE = 'Billet gratuit, ne peut être vendu';

function isFreePreviewPricing(pricing) {
    if (!pricing?.price || typeof pricing.price !== 'object')
        return false;

    const amount = Object.values(pricing.price)[0];
    return Number(amount) === 0;
}

/**
 * Class representing the Lausanne entertainment-tax caption PDF widget.
 * Switches the legal phrase when the preview / ticket pricing amount is 0.
 */
class LausanneEntertainmentTaxWidget extends CustomTextWidget {

    constructor(properties) {
        super({
            ...(LausanneEntertainmentTaxWidget.getDefaultOptions()),
            ...properties,
        });

        this.type    = PdfLayout.TEXT;
        this.subType = PdfLayout.LAUSANNE_ENTERTAINMENT_TAX;
    }

    /**
     * Get this widget default options
     */
    static getDefaultOptions() {
        return {
            position: { x: 2, y: 2, z: 0 },
            dimensions : { width: 4, height: 1.5 },
            transform: { rotation: 0 },
            options: {
                style: {
                    color: '#000000',
                    fontFamily: "Helvetica",
                    fontSize: 11,
                    lineHeight: 1,
                    textAlign: 'center',
                    textDecoration: 'none',
                    textStrokeWidth: 0,
                    textStrokeColor: '#000000',
                    backgroundColor: '#FFFFFF00',
                    borderStyle: 'solid',
                    borderWidth: 0,
                    borderColor: '#000000',
                    borderRadius: 0,
                    padding: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                    },
                    textTransform: 'none'
                },
            }
        };
    }

    /**
     * Return the list of options this widget handles
     */
    getHandledOptions() {
        return super.getHandledOptions().filter(o => o !== PdfLayout.OPTION_TEXT);
    }

    /**
     * Return this widget preview text as string
     *
     * @param {Object} props with at least the following properties:
     *                 - {Bool} inEdition
     *                 - {String} lang
     *                 - {Object} setting
     */
    getPreviewText(props) {
        return isFreePreviewPricing(props?.pricing)
            ? LAUSANNE_ENTERTAINMENT_TAX_FREE
            : LAUSANNE_ENTERTAINMENT_TAX_PAID;
    }

    /**
     * Return the icon to use on the editor button
     */
    getIcon() {
        return 'file-text-o';
    }
}

export default LausanneEntertainmentTaxWidget;
